<template>
  <v-dialog v-model="internalShow" max-width="600">
    <v-card>
      <v-card-title>QR code — {{ customer.name }}</v-card-title>
      <v-card-text class="mb-4">
        <v-row justify="center">
          <img :src="qrCodeLink" width="420" height="420" :alt="`QR Code pour ${customer.name}`" />
        </v-row>
        <v-row justify="center" class="mt-2">
          <span class="text-subtitle-1">{{ customer.name }}</span>
        </v-row>
        <v-row justify="center" class="mt-1">
          <span class="hb-muted">Série: {{ customer.serial }}</span>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="close">Fermer</v-btn>
        <v-spacer />
        <v-btn outlined color="primary" @click="downloadQrCode">Télécharger</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import fileSaver from "file-saver";
  import { mapState } from "vuex";

  export default {
    name: "QrCodeModal",
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      customer: {
        type: Object,
        required: true,
        default: () => ({}),
      },
    },
    computed: {
      ...mapState({
        currentApp: (state) => state.home.app,
      }),
      internalShow: {
        get() {
          return this.show;
        },
        set(value) {
          this.$emit("update:show", value);
        },
      },
      qrCodeLink() {
        const primaryColor = this.currentApp === "hublot" ? "376374" : "9d0419";

        if (!this.customer || !this.customer.serial) {
          return "";
        }
        return `https://quickchart.io/qr?text=${this.customer.serial}&ecLevel=L&size=150&dark=${primaryColor}`;
      },
    },
    methods: {
      close() {
        this.$emit("update:show", false);
      },
      downloadQrCode() {
        if (!this.customer || !this.customer.serial) {
          return;
        }

        // Personnalisation selon l'app
        const emoji = this.currentApp === "carnot" ? "🥩" : "🐟";
        const primaryColor = this.currentApp === "hublot" ? "376374" : "9d0419";
        const caption = `${emoji} ${this.customer.name}`;

        const url = `https://quickchart.io/qr?text=${this.customer.serial}&ecLevel=L&size=800&caption=${encodeURIComponent(caption)}&captionFontFamily=roboto&captionFontSize=20&dark=${primaryColor}`;

        fetch(url)
          .then((response) => response.blob())
          .then((blob) => {
            const appPrefix = this.currentApp === "carnot" ? "boucherie" : "poissonnerie";
            fileSaver.saveAs(
              blob,
              `qr-code-${appPrefix}-${this.customer.name}.jpg`,
            );
          })
          .catch((error) => {
            console.error("Erreur lors du téléchargement du QR code:", error);
					this.$toast?.error?.("Erreur lors du téléchargement du QR code");
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
.v-card {
  border-radius: 12px;
}

.v-card-title {
  padding-bottom: 0;
}

img {
  max-width: 100%;
  height: auto;
  border-radius: var(--radius-md);
  border: 1px solid var(--line);
}
</style>